export function getDefaultTabIndex(tabs: { key: string }[], search: string): number {
  const searchParams = new URLSearchParams(search);
  const index = tabs.findIndex(tab => tab.key === searchParams.get('tab'));

  return index > -1 ? index : 0;
}